import { render, staticRenderFns } from "./BindPhone.vue?vue&type=template&id=0d242a86&scoped=true&"
import script from "./BindPhone.vue?vue&type=script&lang=js&"
export * from "./BindPhone.vue?vue&type=script&lang=js&"
import style0 from "./BindPhone.vue?vue&type=style&index=0&id=0d242a86&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d242a86",
  null
  
)

export default component.exports